<template>
    <div>
        <RedesSociaisEsquerda></RedesSociaisEsquerda>
        <v-breadcrumbs :items="breadcrumb" divider=">"></v-breadcrumbs>  
        <v-container id="novidades">
             
            <v-row>
                <v-col class="col-md text-left my-10">
                    <h2>{{ noticia.titulo }}</h2>
                    <span class="font-weight-light overline dt-publicacao">
                        <span>{{ noticia.dataAtualizacao | moment("dddd, DD/MM/YYYY") }}</span>
                    </span>
                    <v-divider></v-divider>
                   
                    <div class="my-5" >
                        <img :src="noticia.imagem" class="novidade-img-capa"/>
                    </div>
                    <div class="my-5" >
                        <div v-html="noticia.texto">
                            {{ noticia.texto }}
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <router-link to="/novidades" tag="a" class="float-right back-link">Ver mais notícias</router-link>
                </v-col>
            </v-row>            
        </v-container>
    </div>
</template>

<script>
    import API from '../../api'
    import RedesSociaisEsquerda from "../core/RedesSociaisEsquerda";    
    
    export default {
        name: "Novidades",
        metaInfo: {
            // if no subcomponents specify a metaInfo.title, this title will be used
            title: 'Novidades'
        },         
        components: {RedesSociaisEsquerda},
        data: () => ({
            end:false,
            noticia: {},
            breadcrumb: [
                {
                    text: 'Em Busca do Tesouro',
                    disabled: false,
                    href: '/#/principal',
                },
                {
                    text: 'Novidades',
                    disabled: false,
                    href: '/novidades',
                }                          
            ],            
        }),
        mounted(){
            API.noticiaDetalhe(this.$route.params.id).then(res => {
                    this.noticia = res.data.noticia[0];  
                    
                    this.breadcrumb.push({
                    text: res.data.noticia[0].titulo,
                    disabled: true, 
                    });              
                        
            });
            
            

        }
               

    }

    
</script>

<style scoped lang="scss">
    .v-input__slider {
        width: 100%;
    }

    #novidades { 
        padding:0px 50px;
        h2 {
            font-family: Museo300 !important; 
            color: #715392;
        }

        .dt-publicacao {
            font-family: Museo300 !important;
            color: #828282;
        }

        .novidade-img-capa {
            max-width: 100%;
            width: auto;
        }

        .back-link {
            font-size:12px;
            text-decoration: none;
        }

        .novidade-img-capa {
            max-width:600px;
        }

        @media (max-width:764px){
            .novidade-img-capa {
                width:100%;
            }
        }
    }
   
  
</style>
